import { LandingVideoselfingModule } from '../landing-videoselfing/landing-videoselfing.module';
import { RequestsGuard } from './requests.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  REQUESTS_PANEL,
  REQUESTS_CALCULATOR,
  REQUESTS_CALCULATOR_AUTOS,
  REQUESTS_REQUEST_MG,
  REQUESTS_REQUEST,
  REQUESTS_REQUEST_MG_NO_SHOPPING,
  REQUESTS_REQUEST_CG,
  REQUESTS_REQUEST_BP,
  REQUESTS_REQUEST_AUTOS,
  REQUESTS_LOGALTY_CONSENTS,
  REQUESTS_LOGALTY_SIGNATURE,
  REQUESTS_PARTICIPANTS_LIST,
  REQUESTS_PENDING_INE,
  REQUESTS_UPDATE_DOCUMENTATION,
  REQUESTS_SHOW_EDIT,
  REQUESTS_PENDING_VIDEOSELFING,
  REQUESTS_LANDING_VIDEOSELFING,
  REQUESTS_FINISH_VIDEOSELFING,
  REQUEST_LOGALTY_CALL_BACK,
  REQUEST_LOGALTY_CALL_BACK_MERCHANT,
} from '@app/@core/constants/routes.constants';

const routes: Routes = [
  {
    path: REQUESTS_PANEL,
    loadChildren: () => import('./panel/panel.module').then((m) => m.PanelModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_UPDATE_DOCUMENTATION + '/:numOperation',
    loadChildren: () =>
      import('./update-documentation/update-documentation.module').then((m) => m.UpdateDocumentationModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_PENDING_INE,
    loadChildren: () => import('./ine-signature/ine-signature.module').then((m) => m.IneSignatureModule),
  },
  {
    path: REQUESTS_PENDING_VIDEOSELFING,
    loadChildren: () => import('./ine-signature/ine-signature.module').then((m) => m.IneSignatureModule),
  },
  {
    path: REQUESTS_SHOW_EDIT + '/:mode',
    loadChildren: () => import('./request-show-edit/request-show-edit.module').then((m) => m.RequestShowEditModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_CALCULATOR,
    loadChildren: () => import('./calculator/calculator.module').then((m) => m.CalculatorModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_CALCULATOR_AUTOS,
    loadChildren: () => import('./calculator-autos/calculator-autos.module').then((m) => m.CalculatorAutosModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_REQUEST,
    loadChildren: () => import('./request/request.module').then((m) => m.RequestModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_REQUEST_CG,
    loadChildren: () => import('./request/request.module').then((m) => m.RequestModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_REQUEST_MG_NO_SHOPPING,
    loadChildren: () =>
      import('./request-mg-no-shopping/request-mg-no-shopping.module').then((m) => m.RequestMgNoShoppingModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_REQUEST_MG,
    loadChildren: () => import('./request-mg/request-mg.module').then((m) => m.RequestMgModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_REQUEST_BP,
    loadChildren: () => import('./request-bp/request-bp.module').then((m) => m.RequestBpModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_REQUEST_AUTOS,
    loadChildren: () => import('./request-auto/request-auto.module').then((m) => m.RequestAutoModule),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_LOGALTY_CONSENTS,
    loadChildren: () =>
      import('./logalty-digital-signature/logalty-consents/logalty-consents.module').then(
        (m) => m.LogaltyConsentsModule
      ),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_LOGALTY_SIGNATURE,
    loadChildren: () =>
      import('./logalty-digital-signature/logalty-signature/logalty-signature.module').then(
        (m) => m.LogaltySignatureModule
      ),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUESTS_PARTICIPANTS_LIST + '/:numOperation/:isPrintOption/:comarca',
    loadChildren: () =>
      import('./logalty-digital-signature/participants-list/participants-list.module').then(
        (m) => m.ParticipantsListModule
      ),
    canActivate: [RequestsGuard],
  },
  {
    path: REQUEST_LOGALTY_CALL_BACK,
    loadChildren: () => import('../logalty-call-back/logalty-call-back.module').then((m) => m.LogaltyCallBackModule),
  },
  {
    path: REQUEST_LOGALTY_CALL_BACK_MERCHANT,
    loadChildren: () =>
      import('../logalty-call-back-merchant/logalty-call-merchant-back.module').then(
        (m) => m.LogaltyCallBackMerchantModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RequestsRoutingModule {}
